import marker from "./marker";

export default `
${marker}
`;
